module.exports = __webpack_public_path__ + "img/tree17.66812316.png";